function createSentryDeprecationError(methodName) {
    var errorMessage = "Sentry SDK \u5DF2\u4E0B\u7EBF\uFF0C\u8BF7\u79FB\u9664\u5BF9 window.Sentry." + methodName + " \u7684\u8C03\u7528\u3002\u5982\u9700\u9519\u8BEF\u76D1\u63A7\uFF0C\u8BF7\u4F7F\u7528\u89C2\u6D4B\u4E91\u76D1\u63A7\u670D\u52A1\u3002";
    console.error(errorMessage);
}
function createSentryProxy() {
    if (typeof Proxy !== 'undefined') {
        return new Proxy({}, {
            get: function (_target, prop) {
                return function () {
                    var _args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        _args[_i] = arguments[_i];
                    }
                    createSentryDeprecationError(String(prop));
                };
            },
            set: function (_target, prop, _value) {
                createSentryDeprecationError(String(prop) + " (setter)");
                return false;
            },
            has: function (_target, _prop) {
                return true;
            },
            ownKeys: function (_target) {
                return ['captureException', 'captureMessage', 'addBreadcrumb', 'setUser', 'setTag', 'setContext', 'configureScope', 'withScope', 'init'];
            },
            getOwnPropertyDescriptor: function (_target, prop) {
                return {
                    enumerable: true,
                    configurable: true,
                    value: function () {
                        var _args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            _args[_i] = arguments[_i];
                        }
                        createSentryDeprecationError(String(prop));
                    }
                };
            }
        });
    }
    else {
        var sentryObject_1 = {};
        var createErrorFunction_1 = function (methodName) {
            return function () {
                var _args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    _args[_i] = arguments[_i];
                }
                createSentryDeprecationError(methodName);
            };
        };
        var sentryMethods = [
            'captureException', 'captureMessage', 'addBreadcrumb', 'setUser', 'setTag',
            'setContext', 'configureScope', 'withScope', 'init', 'setLevel', 'setFingerprint',
            'setExtra', 'clearScope', 'pushScope', 'popScope', 'getCurrentHub', 'getClient',
            'captureEvent', 'lastEventId', 'flush', 'close', 'startTransaction', 'finishTransaction'
        ];
        sentryMethods.forEach(function (methodName) {
            try {
                Object.defineProperty(sentryObject_1, methodName, {
                    get: function () {
                        return createErrorFunction_1(methodName);
                    },
                    enumerable: true,
                    configurable: true
                });
            }
            catch (e) {
                sentryObject_1[methodName] = createErrorFunction_1(methodName);
            }
        });
        if (typeof Object.defineProperty === 'function') {
            try {
                Object.defineProperty(sentryObject_1, 'hasOwnProperty', {
                    value: function (_prop) {
                        return true;
                    },
                    writable: false,
                    enumerable: false,
                    configurable: false
                });
            }
            catch (e) {
            }
        }
        return sentryObject_1;
    }
}
window.Sentry = createSentryProxy();
